export interface SplitBillTokenDto {
  token: string;
}
export interface SplitBillRemaining {
  amount: number;
  count: number;
  total: number;
  pid: string;
}

export abstract class SplitBillRepository {
  abstract updateTotalSplit(token: string, totalBillSplit: number): Promise<SplitBillTokenDto>;
  abstract getChildSplitToken(token: string, totalBillSplit: number): Promise<SplitBillTokenDto>;
  abstract getRemaining(token: string): Promise<SplitBillRemaining>;
}
